import { t } from "@impero-com/common/utils/i18n";
import {
    notifyRequestError,
    queryClient,
} from "@impero-com/common/utils/query_client";
import { emitNotification } from "@impero-com/ui";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import {
    ControlOperationFailedError,
    PatchUsersUserIdControlsBody,
} from "api/generated/model";
import {
    getGetUsersUserIdControlsQueryKey,
    patchUsersUserIdControls,
} from "api/generated/users/users";
import { STATUS_CODE_ERROR_OPERATION_FAILED } from "utils/errorCodes";

import { invalidateAssignmentCountQuery } from "./useAssignmentCountQuery";

export function useUpdateControlAssignmentsForUserMutation(userId: number) {
    return useMutation({
        mutationFn: (body: PatchUsersUserIdControlsBody) =>
            patchUsersUserIdControls(userId, body),
        onSuccess: async () => {
            emitNotification("success", t("UserManagement_ControlsUpdated"));
            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: getGetUsersUserIdControlsQueryKey(userId),
                }),
                invalidateAssignmentCountQuery(userId.toString()),
            ]);
        },
        onError: (error: AxiosError<ControlOperationFailedError>) => {
            // 460 error is handled by the caller via a modal, so we don't toast it here
            if (error.response?.status === STATUS_CODE_ERROR_OPERATION_FAILED) {
                return;
            }
            notifyRequestError(error);
        },
    });
}
